import script from "./collection-header.vue?vue&type=script&lang=js"
export * from "./collection-header.vue?vue&type=script&lang=js"

import "./collection-header.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__